module.exports = __webpack_public_path__ + "img/Almaty_obl.5554fcd3.png";